import React from "react";
import Style from "../MoneyExchange.module.scss";
import Assets from "../../Layouts/Assets";
import { useDimensions } from "../../../logic/Dimensions";
import { useSelector } from "react-redux";
import IcoMoon from "../../Layouts/IcoMooon";
import { Link } from "react-router-dom";

const ExchangeContent = ({ mobileData }) => {
  const { width } = useDimensions();

  const { activeClass } = useSelector((state) => state.mobile);
  const appStoreQr = mobileData?.details["app-section-app-store-qr-code"]?.url;
  const googlePlayQr =
    mobileData?.details["app-section-app-google-play-qr-code"]?.url;
  
 
  return (
    <>
      <div
        className={
          activeClass ? `${Style.cntwrap} ${Style.loaded}` : Style.cntwrap
        }
      >
        <h2>{mobileData?.details["app-section-main-title"]}</h2>
        <div className={Style.shrtcnt}>
          <p>{mobileData?.details["app-section-main-description"]}</p>
        </div>
        <Link
          to={`${mobileData?.details["app-section-button-url"]?.url}`}
          className={`arw-link ${Style.all_btn}`}
        >
          <span>
            <IcoMoon icon="arrow-right" size={12} />
          </span>
          {mobileData?.details["app-section-button-url"]?.title}
        </Link>
      </div>
      <div className={Style.dwnldapp}>
        {activeClass && <header>Download App </header>}
        {activeClass && (
          <ul className={Style.appstore}>
            <li className={`${!appStoreQr ? Style.noqr : ""}`}>
              <a href={mobileData?.details["app-store-qr-url"]} target="_blank">
                {width > 1200 ? (
                  <>
                    {appStoreQr && <img src={appStoreQr} alt="app-store" />}
                    <img
                      src={
                        mobileData?.details["app-section-app-store-logo-url"]
                          ?.url
                      }
                      alt="app-store"
                      style={
                        !appStoreQr
                          ? {
                              maxWidth: "100%",
                              flexBasis: "auto",
                              width: "auto",
                              margin: "0 auto",
                            }
                          : {}
                      }
                    />
                  </>
                ) : (
                  <img
                    className={Style.mble}
                    src={Assets.applestoremble}
                    alt="app-store"
                  />
                )}
              </a>
            </li>
            <li className={`${!appStoreQr ? Style.noqr : ""}`}>
              {activeClass && (
                <a
                  href={mobileData?.details["google-play-qr-url"]}
                  target="_blank"
                >
                  {width > 1200 ? (
                    <>
                      {googlePlayQr && (
                        <img src={googlePlayQr} alt="app-store" />
                      )}
                      <img
                        src={
                          mobileData?.details[
                            "app-section-app-google-play-logo-url"
                          ]?.url
                        }
                        alt="app-store"
                        style={
                          !googlePlayQr
                            ? {
                                maxWidth: "100%",
                                flexBasis: "auto",
                                width: "auto",
                                margin: "0 auto",
                              }
                            : {}
                        }
                      />
                    </>
                  ) : (
                    <img
                      className={Style.mble}
                      src={Assets.playstore2mble}
                      alt="app-store"
                    />
                  )}
                </a>
              )}
            </li>
          </ul>
        )}
      </div>
    </>
  );
};

export default ExchangeContent;
